import { render, staticRenderFns } from "./home.vue?vue&type=template&id=145a1cfc&scoped=true&lang=html"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a1cfc",
  null
  
)

export default component.exports